export const DATA_SOURCE_KEY_MAPPING = {
  BusinessName: 'businessName',
  BusinessDescription: 'businessDescription',
  BusinessCategories: 'businessCategories',
  BusinessHours: 'businessHours',
  PhoneNumber: 'phoneNumber',
  Emails: 'emails',
  LocationInfo: 'locationInfo',
  LogoImageId: 'logoImageId',
  CoverImage: 'coverImage',
  Photos: 'photos',
  FacebookId: 'facebookId',
  Posts: 'posts',
  Reviews: 'reviews',
  BusinessSummary: 'businessSummary',
  CallToActions: 'callToActions',
};

export const COMPONENT_TYPE_MAPPING = {
  Gallery: 'gallery',
  CoverImage: 'coverImage',
  Update: 'update',
  Review: 'review',
  Summary: 'summary',
  SocialLinks: 'socialLinks',
  Contact: 'contact',
  BusinessHours: 'businessHours',
  Introduction: 'introduction',
  CallToAction: 'callToAction',
  Footer: 'footer',
};

export const DATA_SOURCE_TO_COMPONENT_TYPE_MAPPING = {
  coverImage: 'coverImage',
  photos: 'gallery',
  posts: 'update',
  reviews: 'review',
  businessDescription: 'summary',
  businessSummary: 'summary',
  businessHours: 'businessHours',
};

export const WEBSITE_SOURCE_DATA_KEY_MAPPING = {
  BusinessName: 'BusinessName',
  Description: 'Description',
  Categories: 'Categories',
  SingleLineAddress: 'SingleLineAddress',
  PhoneNumber: 'PhoneNumber',
  CoverImageUrl: 'CoverImageUrl',
  CoverImageId: 'CoverImageId',
  Logo: 'Logo',
  LogoImageId: 'LogoImageId',
  LogoImageUrl: 'LogoImageUrl',
  GalleryImages: 'GalleryImages',
  GalleryImageIds: 'GalleryImageIds',
  Introduction: 'Introduction',
  Subdomain: 'Subdomain',
  Email: 'Email',
  SocialUrls: 'SocialUrls',
  BusinessHours: 'BusinessHours',
  EmbeddedVideos: 'EmbeddedVideos',
  CallToActions: 'CallToActions',
  Locations: 'Locations',
  Theme: 'Theme',
  Services: 'Services',
  Appointment: 'Appointment',
  Reviews: 'Reviews',
  TimeZoneId: 'TimeZoneId',
  PrivacyPolicy: 'PrivacyPolicy',
  Localization: 'Localization',
};

export const WEBSITE_SOURCE_DATA_THEME_KEY_MAPPING = {
  Mode: 'Mode',
  AccentColor: 'AccentColor',
};

export const COMPONENT_TYPE_MIGRATION_STATUS_KEY_MAPPING = {
  Introduction: 'IsIntroductionMigrated',
};

export const DATA_SOURCE_TO_WEBSITE_SOURCE_DATA_MAPPING = {
  businessName: WEBSITE_SOURCE_DATA_KEY_MAPPING.BusinessName,
  businessDescription: WEBSITE_SOURCE_DATA_KEY_MAPPING.Description,
  businessCategories: WEBSITE_SOURCE_DATA_KEY_MAPPING.Categories,
  phoneNumber: WEBSITE_SOURCE_DATA_KEY_MAPPING.PhoneNumber,
  locationInfo: WEBSITE_SOURCE_DATA_KEY_MAPPING.SingleLineAddress,
  // Note: emails: array, Email: string, the conversion needs to be handled specifically
  emails: WEBSITE_SOURCE_DATA_KEY_MAPPING.Email,
  callToActions: WEBSITE_SOURCE_DATA_KEY_MAPPING.CallToActions,
  logoImageId: WEBSITE_SOURCE_DATA_KEY_MAPPING.LogoImageId,
  businessHours: WEBSITE_SOURCE_DATA_KEY_MAPPING.BusinessHours,
};

export const COMPONENT_TO_WEBSITE_SOURCE_DATA_MAPPING = {
  video: WEBSITE_SOURCE_DATA_KEY_MAPPING.EmbeddedVideos,
  professionalService: WEBSITE_SOURCE_DATA_KEY_MAPPING.Services,
};
